// extracted by mini-css-extract-plugin
module.exports = {"TableHeader":"TableHeader_TableHeader__36hxH"};